import { SearchFormProps } from './interface'

export function withSearchForm(Component: React.FC<SearchFormProps>) {
  function WithSearchForm(props: SearchFormProps) {
    return <Component {...props} />
  }

  return WithSearchForm
}
